import Modal from 'react-modal'
import { Drawer } from 'antd'

const BaseDrawer = ({
  drawerOpen,
  closeHandler,
  children,
  title,
  width = "33%",
  bodyStyle,
  titleClasses,
  showCloseIcon,
  className
}) => {
  const onClose = ()=>{
    closeHandler();
  }

  return(
    <Drawer
      visible={drawerOpen}
      onClose={onClose}
      width={width}
      closeIcon={showCloseIcon ? 'x' : null}
      bodyStyle={bodyStyle}
      maskClosable={false}
      zIndex={10}
      className={className}
    >
      {!!title && <h1 className={`ttnk-page__title uppercase m-0 ${String(titleClasses)}`}>{title}</h1>}
      { children }
    </Drawer>
  )
}

export default BaseDrawer
